import React, { useContext, useRef } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import LogisticsGrid from './LogisticsGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import useLogisticsPresenter from './LogisticsPresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
//import CustomDatePicker from '../../components/UI/CustomDatePicker';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { strToDate, DATE_FORMAT, todayLastYearDate } from '../../utils/DateUtils';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const {
    selectedSupplier,
    setSelectedSupplier,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    client,
    setClient,
    reference,
    setReference,
    validateAndSearch,
    cleanFilters,
  } = filtersProps;

  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <CustomDatePicker2 value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker2 value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />
      <TextField
        style={{ width: 150 }}
        margin="dense"
        id="client"
        label="Cliente"
        onChange={e => setClient(e.target.value)}
        value={client}
      />
      <TextField
        style={{ width: 150 }}
        margin="dense"
        id="reference"
        label="Nro. de remito"
        onChange={e => setReference(e.target.value)}
        value={reference}
      />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const CustomDatePicker2 = ({
  value,
  setValue,
  minDate,
  maxDate,
  label,
  disablePast,
  readOnly,
  disabled,
  style,
  disableMinDate,
  ...restProps
}) => {
  const handleBlur = e => {
    const dateValue = e.target.value;
    setValue(dateValue.isBlank() ? null : strToDate(dateValue));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        style={{ width: 140, ...style }}
        disableToolbar
        disablePast={disablePast}
        disabled={disabled}
        autoOk
        variant="inline"
        format={DATE_FORMAT}
        margin="dense"
        invalidDateMessage="Fecha incorrecta"
        id={`date-picker-inline-${label}`}
        label={label || 'Fecha'}
        minDate={readOnly || minDate || disableMinDate ? minDate : undefined}
        maxDate={maxDate || undefined}
        value={value}
        onChange={() => undefined}
        onAccept={setValue}
        onBlur={!readOnly ? handleBlur : undefined}
        inputProps={{ readOnly: !!readOnly }}
        KeyboardButtonProps={{
          disabled: !!readOnly || !!disabled,
          'aria-label': 'change date',
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  );
};

const Logistics = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useLogisticsPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <LogisticsGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default Logistics;
